// 插件端初始化
import StorageUtils from './core/storageUtils'
import { InitDesktopClient } from '@/core/desktopUtils'
import DesktopListener from '@/core/desktopListener'
import { MessageBox } from 'element-ui'
import Http from '@/core/axios'

const apiHost = process.env.VUE_APP_BASE_API

export const initDesktop = function ({ Vue, Store, Router }, { softwareCode, softwareVersion }) {
  return new Promise((resolve) => {
    InitDesktopClient((errorCode, errorMessage) => {
      if (errorCode === 'request.method.not.found') {
        MessageBox.confirm('您的软件版本可能较低, 建议升级后使用此功能！' + errorMessage, '提示', {
          type: 'warning',
          showCancelButton: false
        })
      }
    }).then(async (client) => {
      // 如果软件代码为 AppGbr，则需要转换为构件坞可识别的软件版本（2025.630-->2.7）
      const res = softwareCode === 'AppGbr' ? await Http.get(`${apiHost}/data_standards/v1/software/software_versions`, {
        software_code: softwareCode
      }) : []
      const matched = res.find((item) => item.displayVersion === softwareVersion) || {}
      softwareVersion = matched.softwareVersion || softwareVersion

      Vue.prototype.$desktopClient = client
      if ((!softwareCode || !softwareVersion)) {
        const res = await client.GetDesktopInfo()
        const data = res.data || {}
        softwareCode = data.hostAppName
        softwareVersion = data.hostAppVersion
      }
      let localAppData = await client.GetSpecialFolder('LocalApplicationData')
      if (localAppData && localAppData.code === 'success') {
        localAppData = localAppData.data
      }
      const desktopInfo = await client.GetDesktopInfo()
      if (desktopInfo && desktopInfo.code === 'success') {
        StorageUtils.sessionStorage.set('desktopInfo', desktopInfo.data)
        Store.commit('setDesktopInfo', desktopInfo.data)
      }

      StorageUtils.sessionStorage.set('softwareCode', softwareCode)
      StorageUtils.sessionStorage.set('softwareVersion', softwareVersion)
      StorageUtils.sessionStorage.set('localAppData', localAppData)
      Store.commit('setSoftwareCode', softwareCode)
      Store.commit('setSoftwareVersion', softwareVersion)
      Store.commit('setLocalAppData', localAppData)

      // 插件修改浏览器 userAgent 使埋点时能正确解析为端应用
      Object.defineProperty(navigator, 'userAgent', {
        value: 'Mozilla/5.0',
        writable: false
      })

      // 监听桌面端调用
      window.DesktopListener = new DesktopListener({ Vue, Router })

      resolve()
    })
  })
}
